import React from "react";
import TitleDetail from "../atoms/TitleDetail";
import InputGroup from "../atoms/InputGroup";
import { data } from "autoprefixer";

const SensorDetail = ({ data, quality,index }) => {
  // console.log(index,data)
  return (
    <div>
      <TitleDetail title={`اطلاعات سنسور ${index+1}`} />
      <div className="flex flex-row justify-between w-full gap-5 mt-25">
        <InputGroup
          icon={false}
          readOnly={true}
          label={"نام نمایشی سنسور (نمایش برای کاربر)"}
          value={data.username}
        />
        <InputGroup
          icon={false}
          readOnly={true}
          label={"نام قراردادی (استفاده در JSON)"}
          value={data.jsonname}
        />
        <InputGroup
          icon={false}
          readOnly={true}
          label={"واحد اندازه گیری"}
          value={data.measurunit}
        />
      </div>
      {quality === true ? (
        <>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              icon={false}
              readOnly={true}
              label={"بیشترین شاخص"}
              value={data.maxIndex}
            />
            <InputGroup
              icon={false}
              readOnly={true}
              label={"کمترین شاخص"}
              value={data.minIndex}
            />
            <InputGroup
              icon={false}
              readOnly={true}
              label={"بیشترین مقدار"}
              value={data.maxamount}
            />
            <InputGroup
              icon={false}
              readOnly={true}
              label={"کمترین مقدار"}
              value={data.minamount}
            />
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-row justify-between  gap-5 mt-25">
            <InputGroup
              icon={false}
              readOnly={true}
              label={"بیشترین مقدار"}
              value={data.maxamount}
            />
            <InputGroup
              icon={false}
              readOnly={true}
              label={"کمترین مقدار"}
              value={data.minamount}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default SensorDetail;
